import { useTranslation } from "react-i18next";
import { parseJsonObject } from "@/lib/utils";

export function configurationChanges(before: string, after: string) {
  try {
    const previous = parseJsonObject(before);
    const next = parseJsonObject(after);
    return [...new Set([...Object.keys(previous), ...Object.keys(next)])]
      .filter((key) => JSON.stringify(previous[key]) !== JSON.stringify(next[key]))
      .map((key) => ({ key, before: previous[key], after: next[key] }));
  } catch { return []; }
}

export function ConfigurationChangeSummary({ beforeEntitlements, entitlements, beforePolicy, policy }: {
  beforeEntitlements: string; entitlements: string; beforePolicy: string; policy: string;
}) {
  const { t } = useTranslation();
  const changes = [
    ...configurationChanges(beforeEntitlements, entitlements).map((v) => ({ ...v, group: "Entitlement" })),
    ...configurationChanges(beforePolicy, policy).map((v) => ({ ...v, group: "Policy" })),
  ];
  if (!changes.length) return null;
  const display = (value: unknown) => value === undefined ? t("configurationEditor.omitted", "Omitted") : JSON.stringify(value);
  return <section className="space-y-3 border-t border-line pt-4" aria-label={t("configurationEditor.reviewChanges", "Review changes")}>
    <h3 className="text-sm font-medium">{t("configurationEditor.reviewChanges", "Review changes")}</h3>
    {changes.map((change) => <div key={`${change.group}:${change.key}`} className="grid min-w-0 gap-2 border-b border-line pb-3 text-xs sm:grid-cols-[minmax(0,1fr)_minmax(0,1fr)]">
      <p className="break-all font-mono sm:col-span-2">{change.group} · {change.key}</p>
      <div className="min-w-0"><p className="text-muted">{t("dialogs.before", "Before")}</p><p className="whitespace-pre-wrap break-all font-mono">{display(change.before)}</p></div>
      <div className="min-w-0"><p className="text-muted">{t("dialogs.after", "After")}</p><p className="whitespace-pre-wrap break-all font-mono">{display(change.after)}</p></div>
    </div>)}
  </section>;
}
